import React from 'react'
import { AmountAndRecurringSelectionProps } from 'donate/types'
import { AmountField, RecurringSelection } from '.'

export const AmountAndRecurringSelection = ({
  config: _config,
  formik,
}: AmountAndRecurringSelectionProps): JSX.Element => {
  return (
    <div className="donations-form-amount-selection">
      <h4 className="amount-headline">{i18n.t('donate.attributes.amount')}</h4>
      <div className="amount-wrapper desktop:mb-3">
        <div className="amount-input-wrapper">
          <AmountField hideError />
        </div>
      </div>
      <div className="donations-form-recurring-selection">
        <RecurringSelection />
      </div>
      <div className="amount-error">
        {formik.errors.amount_cents && formik.touched.amount_cents && (
          <div className="help-inline">{formik.errors.amount_cents}</div>
        )}
      </div>
    </div>
  )
}
